import Config from '@config';
import { CACHE_EXPIRATION_TIME } from '@gasbi/shared/common/features/constants';
import {
  FiltersGrid,
  Pagination,
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@gasbi/shared/index';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { PsgTariff, PsgTariffRequestBody, PsgTariffUpdateBody } from './types';

export const psgTariffsApi = createApi({
  reducerPath: 'psgTariffsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/psg-tariffs`,
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  tagTypes: ['PsgTariff', 'PsgTariffs'],
  endpoints: builder => ({
    getPsgTariffsI: builder.infiniteQuery<PsgTariff[], FiltersGrid, Pagination>(
      {
        infiniteQueryOptions,
        query: ({ queryArg, pageParam }) => ({
          url: `/`,
          params: { ...queryArg, ...pageParam },
        }),
        providesTags: () => ['PsgTariff', 'PsgTariffs'],
      },
    ),
    createPsgTariff: builder.mutation<string, PsgTariffRequestBody>({
      query: data => ({
        url: '/',
        method: 'POST',
        data,
      }),
      invalidatesTags: () => ['PsgTariffs'],
    }),
    updatePsgTariff: builder.mutation<
      void,
      { id: string } & PsgTariffUpdateBody
    >({
      query: ({ id, ...data }) => ({
        url: `/${id}`,
        method: 'PUT',
        data,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        'PsgTariffs',
        { type: 'PsgTariff', id },
      ],
    }),
  }),
});

export const { useCreatePsgTariffMutation, useUpdatePsgTariffMutation } =
  psgTariffsApi;

export const useGetPsgTariffsInfiniteQuery =
  normalizeInfiniteQueryData<PsgTariff>(
    psgTariffsApi.useGetPsgTariffsIInfiniteQuery,
  );
